export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            平台介绍
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于我们
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              <strong className="text-foreground-900">樱花动漫之家</strong>成立于 2020 年，是一个由日漫爱好者创建、服务于日漫爱好者的日本漫画资源聚合与推荐平台。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们的编辑团队由一群深耕日漫领域多年的资深读者组成，覆盖少年漫画、少女漫画、青年漫画等多个类型领域。
              每天，我们追踪日本各大漫画杂志的连载动态，筛选全网热议的日漫话题，为漫友提供高质量的<strong className="text-foreground-900">日漫推荐</strong>与<strong className="text-foreground-900">日漫排行</strong>服务。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              截至目前，平台已累计收录超过 <strong className="text-primary-600">12,000 部日本漫画</strong>信息，每日更新超过 <strong className="text-primary-600">200 个章节</strong>动态，
              月活跃用户突破 <strong className="text-primary-600">50 万</strong>，已成为中文互联网上最活跃的日漫社区之一。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              我们相信，每一部好的日本漫画都值得被更多人看到。樱花动漫之家将持续为漫友打造温暖、专业、有深度的日漫阅读推荐体验，
              让追更成为一种享受，让好作品不再被埋没。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}